import { defineMessages } from 'react-intl';

export default defineMessages({
    saving: {
        id: 'ml.policychange.MLAddVehicleOperatorPopup.saving',
        defaultMessage: 'Saving...'
    },
    addDriver: {
        id: 'ml.policychange.MLAddVehicleOperatorPopup.Add Driver',
        defaultMessage: 'ADD DRIVER'
    },
    editDriver: {
        id: 'ml.policychange.MLAddVehicleOperatorPopup.Edit Driver',
        defaultMessage: 'EDIT DRIVER'
    },
    maritalStatusTitle: {
        id: 'ml.policychange.MLAddVehicleOperatorPopup.What is civil union vs domestic partner?',
        defaultMessage: 'What is civil union vs domestic partner?'
    },
    maritalStatus: {
        id: 'ml.policychange.MLAddVehicleOperatorPopup.Marital Status Tooltip Content',
        defaultMessage: 'A civil union is defined as a state level legally recognized same-sex marriage. A domestic partner is a relationship between two individuals (same-or opposite-sex) who live together but are not married.'
    },
    nonUniqueSelf: {
        id: 'ml.policychange.MLAddVehicleOperatorPopup.Self has already been selected as a relationship to insured on another driver',
        defaultMessage: 'Self has already been selected as a relationship to insured on another driver.'
    },
    nonUniqueSpouse: {
        id: 'ml.policychange.MLAddVehicleOperatorPopup.Spouse was already selected as a relationship to insured on another driver',
        defaultMessage: 'Spouse was already selected as a relationship to insured on another driver.'
    },
});